<template>
	<div class="custom-header">
		<input
			type="checkbox"
			class="mycheck"
			:class="params.column.colId === 'isPickup' ? 'pickup' : 'delivery'"
			:title="$t('SelectAll')"
			:checked="params.isChecked"
			@change="onCheckboxChange"
		/>
		<span style="font-size: 14px; font-weight: bold">{{ params.displayName }}</span>
	</div>
</template>

<script>
export default {
	methods: {
		onCheckboxChange(event) {
			this.params.onCheckboxChange(event.target.checked);
		},
	},
};
</script>

<style lang="scss" scoped>
.custom-header {
	display: flex;
	align-items: center;
	flex-direction: column;
}
.mycheck {
	cursor: pointer;
	background-color: #fff;
	background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
	width: 16px;
	height: 16px;
	appearance: none;
	border: 2px solid #888;
	transition: background-color 0.3s ease-in-out;
}

.mycheck.pickup:checked {
	background-color: #420d91;
}

.mycheck.delivery:checked {
	background-color: rgba(var(--vs-warning), 1);
}

.mycheck.pickup:focus {
	border-color: rgba(var(--vs-primary), 1);
}

.mycheck.delivery:focus {
	border-color: rgba(var(--vs-warning), 1);
}

.mycheck:disabled {
	background-color: #ccc;
	background-image: none;
}

.mycheck:disabled:checked {
	background-color: #ccc;
	background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
}
</style>
